const TURNSTILE_SCRIPT_ID = "cloudflare-turnstile-script";
const TURNSTILE_SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

let scriptLoadPromise = null;
let widgetId = null;

const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim() || "";

function isTurnstileEnabled() {
  return siteKey.length > 0;
}

function loadTurnstileScript() {
  if (!isTurnstileEnabled()) {
    return Promise.resolve(null);
  }
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }
  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }

  scriptLoadPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(TURNSTILE_SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", () => resolve(window.turnstile));
      existing.addEventListener("error", () => reject(new Error("Turnstile script failed to load")));
      return;
    }

    const script = document.createElement("script");
    script.id = TURNSTILE_SCRIPT_ID;
    script.src = TURNSTILE_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.turnstile);
    script.onerror = () => reject(new Error("Turnstile script failed to load"));
    document.head.appendChild(script);
  });

  return scriptLoadPromise;
}

function ensureWidgetContainer() {
  let container = document.getElementById("turnstile-widget");
  if (!container) {
    container = document.createElement("div");
    container.id = "turnstile-widget";
    container.style.display = "none";
    document.body.appendChild(container);
  }
  return container;
}

async function ensureWidget() {
  const turnstile = await loadTurnstileScript();
  if (!turnstile) {
    return null;
  }

  if (widgetId != null) {
    return turnstile;
  }

  await new Promise((resolve) => {
    turnstile.ready(resolve);
  });

  const container = ensureWidgetContainer();
  widgetId = turnstile.render(container, {
    sitekey: siteKey,
    size: "invisible"
  });

  return turnstile;
}

export async function getTurnstileToken() {
  if (!isTurnstileEnabled()) {
    return null;
  }

  const turnstile = await ensureWidget();
  if (!turnstile || widgetId == null) {
    return null;
  }

  return new Promise((resolve, reject) => {
    turnstile.execute(widgetId, {
      action: "vote",
      callback: (token) => resolve(token),
      "error-callback": () => reject(new Error("Turnstile challenge failed")),
      "expired-callback": () => reject(new Error("Turnstile token expired"))
    });
  });
}
